import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Chip, Divider, Grid, Paper, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ArrowForward, ArrowRight, ExpandMore, KeyboardArrowRight } from '@mui/icons-material';
import Global from '../../../customlib/Global';

class RiwayatLabelMobile extends Component {
    state = { } 

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Riwayat Perubahan Label"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}>
                    </Filter>
                    {
                    this.props.listMycustomer.map((lead, index) => {
                        return (
                            <Accordion key={`key-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <strong>{lead.fromName}</strong>
                                        </Grid>
                                        <Grid item xs={12} textAlign={"left"} sx={{pr: "5px"}}>
                                            <Chip size='small' label={lead.lastLabel} variant='outlined' />
                                            <ArrowForward /> 
                                            <Chip size='small' label={lead.currentLabel} variant='contained' color='secondary' />
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box elevation={2} sx={{mb: "10px", padding: "0px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <Typography component="span">Nomor</Typography>
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                {Global.maskPhoneNumber(lead.from)}
                                            </Grid>
                                        </Grid>
                                        <Divider />
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <Typography component="span">Tanggal Leads</Typography>
                                                {/* {lead.label} */}
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                {lead.createdAtFormatted}
                                            </Grid>
                                        </Grid>
                                        <Divider />
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <Typography component="span">Waktu Label Akhir</Typography>
                                                {/* {lead.label} */}
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                {lead.lastLabelAt}
                                            </Grid>
                                        </Grid>
                                        <Divider />
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <Typography component="span">Chat Terakhir</Typography>
                                                {/* {lead.label} */}
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                {lead.lastMessageReceivedAtFormatted}
                                            </Grid>
                                        </Grid>
                                        <Divider />
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                }
                </Box>
            </Box>
        );
    }
}
 
export default RiwayatLabelMobile;